import type { Role } from "@/types";
import type { IconName } from "@/components/ui/icon";

/* Iconos SVG compartidos por la navegacion de todos los roles. */
export interface NavigationItem {
  label: string;
  href: string;
  icon: IconName;
  end?: boolean;
}

export interface NavigationSection {
  heading: string;
  items: NavigationItem[];
}

const participant: NavigationSection[] = [
  {
    heading: "Aprendizaje",
    items: [
      { label: "Mi panel", href: "/dashboard", icon: "dashboard", end: true },
      { label: "Mis cursos", href: "/my-courses", icon: "menu_book" },
      { label: "Explorar", href: "/catalog", icon: "local_library" },
      { label: "Evaluaciones", href: "/results", icon: "assignment_turned_in" },
    ],
  },
  {
    heading: "Cumplimiento",
    items: [
      { label: "Documentos", href: "/my-documents", icon: "description" },
      { label: "Certificados", href: "/certificates", icon: "card_membership" },
      {
        label: "Notificaciones",
        href: "/notifications",
        icon: "notifications_none",
      },
    ],
  },
];

const administration: NavigationSection[] = [
  {
    heading: "Institucion",
    items: [
      {
        label: "Resumen ejecutivo",
        href: "/dashboard",
        icon: "dashboard",
        end: true,
      },
      { label: "Usuarios", href: "/admin/users", icon: "people" },
      { label: "Organizacion", href: "/admin/organization", icon: "business" },
    ],
  },
  {
    heading: "Capacitacion",
    items: [
      { label: "Capacitaciones", href: "/admin/courses", icon: "school" },
      { label: "Documentos", href: "/admin/documents", icon: "folder_shared" },
      {
        label: "Banco de preguntas",
        href: "/admin/questions",
        icon: "help_outline",
      },
      { label: "Evaluaciones", href: "/admin/exams", icon: "assignment" },
    ],
  },
  {
    heading: "Control",
    items: [
      {
        label: "Comunicaciones",
        href: "/admin/communications",
        icon: "mail_outline",
      },
      { label: "Reportes", href: "/admin/reports", icon: "insert_chart" },
      { label: "Bitacora", href: "/admin/audit", icon: "history" },
    ],
  },
];

const instructor: NavigationSection[] = [
  {
    heading: "Instructor",
    items: [
      {
        label: "Panel del instructor",
        href: "/dashboard",
        icon: "dashboard",
        end: true,
      },
      { label: "Mis capacitaciones", href: "/admin/courses", icon: "school" },
    ],
  },
  {
    heading: "Evaluacion",
    items: [
      {
        label: "Banco de preguntas",
        href: "/admin/questions",
        icon: "help_outline",
      },
      { label: "Evaluaciones", href: "/admin/exams", icon: "assignment" },
      { label: "Reportes", href: "/admin/reports", icon: "insert_chart" },
    ],
  },
];

const auditor: NavigationSection[] = [
  {
    heading: "Auditoria",
    items: [
      {
        label: "Panel de auditoria",
        href: "/dashboard",
        icon: "verified_user",
        end: true,
      },
      { label: "Reportes", href: "/admin/reports", icon: "insert_chart" },
      { label: "Bitacora", href: "/admin/audit", icon: "history" },
    ],
  },
  {
    heading: "Evidencia",
    items: [
      { label: "Capacitaciones", href: "/admin/courses", icon: "school" },
      { label: "Usuarios", href: "/admin/users", icon: "people" },
      { label: "Documentos", href: "/admin/documents", icon: "folder_shared" },
      {
        label: "Comunicaciones",
        href: "/admin/communications",
        icon: "mail_outline",
      },
    ],
  },
];

export function navigationFor(role: Role): NavigationSection[] {
  if (role === "PARTICIPANT") return participant;
  if (role === "INSTRUCTOR") return instructor;
  if (role === "AUDITOR") return auditor;
  return administration;
}
